import { createRequiredValidators } from "@xo/client-common";
import { Type2Link } from "./Type2Link";

export function createType2LinkValidators() {
    return [
        ...createRequiredValidators<Type2Link>(["simpleField", "validatedField", "arrayField", "mixed"]),
    ];
}
